import React from "react";
import styles from "../../assets/scss/componnetScss/header.module.scss"; // Ensure you have the SCSS file
import { Link } from "react-router-dom";

const Hearder = ({ title,breadcrumb1, breadcrumb }) => {
  return (
    <>
      <section
        className={styles.banner}
        style={{ backgroundImage: `url("/images/header.png")` }}
      >
        <div className={styles.overlay}>
          <h1 className={styles.title}>{title}</h1>
          <span className={styles.arrow}>↓</span>
        </div>
      </section>

      <div className={styles.breadcrumbContainer}>
        <div className="container">
          <p className={styles.breadcrumb}><Link style={{ textDecoration: 'none', color: 'inherit' }} to="/">Home /</Link> {breadcrumb1 && <Link style={{ textDecoration: 'none', color: 'inherit' }} to={`/${breadcrumb1}`}>{breadcrumb1} /</Link>}  {breadcrumb}</p>

        </div>
      </div>
    </>
  );
};

export default Hearder;
